import React, { useState, useEffect } from 'react';

const ChatStreamSimulator = ({
  message = '',
  typingSpeed = 30,
  onComplete = () => {},
  className = '',
  showCursor = true,
}) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    // Reset when message changes
    setDisplayedText('');
    setCurrentIndex(0);
    setIsComplete(false);
  }, [message]);

  useEffect(() => {
    if (isPaused || isComplete) return;
    
    if (currentIndex < message.length) {
      const timer = setTimeout(() => {
        // Add next character
        setDisplayedText(prev => prev + message[currentIndex]);
        setCurrentIndex(prev => prev + 1);
        
        // Simulate variable typing speed for realism
        const nextChar = message[currentIndex + 1];
        if (nextChar === ':' || nextChar === '.' || nextChar === '?' || nextChar === '!') {
          setIsPaused(true);
          setTimeout(() => setIsPaused(false), typingSpeed * 10);
        }
      }, typingSpeed);
      
      return () => clearTimeout(timer);
    } else if (!isComplete) {
      setIsComplete(true);
      onComplete();
    }
  }, [currentIndex, message, typingSpeed, isComplete, onComplete, isPaused]);

  const handlePauseResume = () => {
    setIsPaused(prev => !prev);
  };
  
  return (
    <span>
        {displayedText}{showCursor && !isComplete && <span className="cursor-blink"> ▌</span>}
    </span>
  );
};

export default ChatStreamSimulator;